import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 2 }

import { ref, computed, reactive, onMounted } from 'vue'
import { businessList, businessDelete, businessDetails } from '@/api/overseasSales/chanceManage'
import dataConfig from '@/views/overseasSales/commonEnum/dataConfig'
import BusinessName from '@/components/BusinessName/index.vue'
import Modal from '@/hooks/modalType'
import { useRoute, useRouter } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import { BusinessListItem } from '@/typings/api/chanceManage'
import { tableIdByPath } from '@/utils'
import { useI18n } from 'vue-i18n'
import { listByParamCodes } from '@/api/common'
import type { ParamCodeItem } from '@/typings/common'
import { useInteractionStore } from '@/stores/interaction'

const __default__ = { name: 'tabsBusiness' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  arkCodeId: {
    type: String
  }
},
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const tableRef = ref()
const props = __props
const shareInfo = useInteractionStore()
const eumns = {
  'en-US': 'enName',
  'zh-CN': 'cnName'
}
const paramCodeData = reactive<{
  [key: string]: ParamCodeItem[]
}>({
  ofbu_currency: [], // 币种
  ofbu_demand_info: [], // 区域仓(需求海外仓参数)
  ofbu_shipments: [] // 发货量
})
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_currency', 'ofbu_demand_info', 'ofbu_shipments']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
/// 用来匹配商机名字的区域仓名
const getDemandInfoName = (headDestinationId?: number) => {
  const find = paramCodeData.ofbu_demand_info?.find((item) => item.id === headDestinationId)
  if (find) {
    return find[eumns[shareInfo.language]] ?? find.name
  }
  return headDestinationId || ''
}
const fetch = (queryForm: object, callBack: (res: any) => void) => {
  if (route.query.cosId) {
    businessList({
      arkCodeId: props.arkCodeId,
      saleChanceRefId: route.query.cosId as string,
      ...queryForm
    }).then((res) => {
      callBack(res)
    })
  } else {
    setTimeout(() => {
      callBack([])
    }, 500)
  }
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}
// 编辑
const handleEdit = (row: BusinessListItem) => {
  router.push({
    path: '/ofbu/business/edit',
    query: {
      id: row.id,
      returnPath: route.fullPath
    }
  })
}
// 删除
const handleDelete = (row: BusinessListItem) => {
  Modal.delete({
    name: row.saleChanceNameByTxt,
    onOk() {
      businessDelete({ id: row.id }).then(() => {
        message.success(t('business.bp7zke'))
        tableRef.value.delFetch()
      })
    }
  })
}
// 商机状态枚举
const statusEnum = computed(() => {
  const list = dataConfig.businessStatusEnum.map((item) => ({
    name: t(item.lang),
    value: item.value,
    color: item.color
  }))
  return list
})
const columns = computed(() => [
  { title: t('business.pehfv5'), dataIndex: 'saleChanceName', fixed: 'left', width: 200 },
  { title: t('business.nnrhea'), dataIndex: 'arkCode' },
  { title: t('common.contactName'), dataIndex: 'contactName', cosType: 'mask' },
  { title: t('common.mobile'), dataIndex: 'contactMobile', cosType: 'mask' },
  { title: t('business.kolh0f'), dataIndex: 'currency', dicData: paramCodeData.ofbu_currency },
  { title: t('business.t3fsg4'), dataIndex: 'shipments', dicData: paramCodeData.ofbu_shipments },
  { title: t('business.me6p1g'), dataIndex: 'headDestinationCountryWarehouse', dicData: paramCodeData.ofbu_demand_info },
  { title: t('business.7xsihs'), dataIndex: 'status' },
  { title: t('custom.opportunityCreateTime'), dataIndex: 'createTime', width: 190 },
  {
    title: t('common.action'),
    dataIndex: 'action',
    fixed: 'right',
    langWidth: {
      zh: 100,
      en: 130
    }
  }
])
onMounted(() => {
  getByParamCodes()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_cos_table, {
    columns: columns.value,
    onFetch: fetch,
    onMask: showMask,
    tableId: _unref(tableIdByPath)('business'),
    ref_key: "tableRef",
    ref: tableRef,
    rowKey: "id"
  }, {
    bodyCell: _withCtx(({ column, record, text }) => [
      (column.dataIndex === 'saleChanceName')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: '/ofbu/business/view?id=' + record.id
          }, {
            default: _withCtx(() => [
              (record.arkCode)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (record.headDestinationCountryWarehouse)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(`${record.arkCode}+${getDemandInfoName(record.headDestinationCountryWarehouse)}`), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(record.arkCode), 1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (record.headDestinationCountryWarehouse)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(getDemandInfoName(record.headDestinationCountryWarehouse)), 1))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("--")
                        ], 64))
                  ], 64))
            ]),
            _: 2
          }, 1032, ["to"]))
        : _createCommentVNode("", true),
      (column.dataIndex === 'status')
        ? (_openBlock(), _createBlock(_component_dc_status, {
            key: 1,
            enums: statusEnum.value,
            value: text
          }, null, 8, ["enums", "value"]))
        : _createCommentVNode("", true),
      (column.dataIndex === '$currency')
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(`${record.planSaleAmount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${text}`), 1))
        : _createCommentVNode("", true),
      (column.dataIndex === 'action')
        ? (_openBlock(), _createBlock(_component_MoreButton, { key: 3 }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                type: "link",
                onClick: ($event: any) => (handleEdit(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.edit')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, __props.permissionPage?.edit]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (handleDelete(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('btn.del')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_permission, __props.permissionPage?.del]
              ])
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns", "tableId"]))
}
}

})